app.controller('OrderReplacementEntryController', ['$rootScope', '$scope', '$stateParams', '$state', function ($rootScope, $scope, $stateParams, $state) {

    const siteHelper = $rootScope.site_helper;
    $scope.is_acknowledgement = !!$state && !!$state.current && !!$state.current.data && !!$state.current.data.is_acknowledgement;
    $scope.is_staff_view = false;
    $scope.visible_customer = null;

    $scope.replacement_id = $stateParams.replacement_id;
    $scope.waiting_for_data = !!$scope.replacement_id;

    $scope.visible_replacement = null;

    $rootScope.model.order_replacement.requireFaultTypes();
    let originalOrder = null;

    $scope.view_model = {
        form_disabled: false,
        user_message: "",
        user_images: [],
        show_photo_form: false,
        have_fault_type: false
    }

    $scope.image_file_upload_model = {
        config_id: "replacement_image",
        file_upload_limit: 1,
        final_files: $scope.view_model.user_images
    }

    let documentProductTag = "replacement_order" ;
    $scope.replacement_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([documentProductTag], function (documents) {
        $scope.replacement_document = documents.length > 0 ? documents[0] : null;
    })

    $scope.toggleMessagePhoto = function () {
        $scope.view_model.show_photo_form = !$scope.view_model.show_photo_form;
    }

    if ($scope.waiting_for_data) {
        $rootScope.service.order_replacement.requestReplacementEntry($scope.replacement_id, function (success, replacement) {
            $scope.visible_replacement = success ? replacement : null;
            if(!$scope.visible_replacement || !$scope.visible_replacement.order_id){
                $scope.waiting_for_data = false;
                return;
            }
            applyMessages(false, !!$scope.visible_replacement._date_payment_accept);

            replacement.lines = replacement.lines ? replacement.lines: []

            for(let i = 0; i < replacement.lines.length; i ++){
                const line = replacement.lines[i];
                if(line.fault_id || line.fault_type){
                    $scope.view_model.have_fault_type = true;
                    line.order_line = [];
                }
            }

            $rootScope.service.order.requestOrder(replacement.order_id, function (success, order) {
                if(success && order){
                    originalOrder = order;
                    order.lines = order.lines ? order.lines: []
                    for(let i = 0; i < replacement.lines.length; i ++){
                        let replacementLine = replacement.lines[i];
                        if(replacementLine.order_line_id){
                            let lineIndex = parseInt(replacementLine.order_line_id) - 1;
                            const orderLine = order.lines[lineIndex];
                            replacementLine.order_line =  orderLine ? orderLine : {};
                        }
                    }
                }
                $rootScope.service.account.requireUserData(function () {
                    $scope.is_staff_view = $rootScope.model.staff.is_staff_or_rep;
                    if ($scope.is_staff_view) {

                        $rootScope.service.staff.requestCustomerData($scope.visible_replacement.customer_code, function (success, customerData) {
                            const applyReplacement = () => {
                                $scope.visible_customer = success ? customerData : null;
                                $scope.waiting_for_data = false;
                            }
                            if($scope.visible_replacement.customer_code === $rootScope.model.staff.staff_rep_customer_code){
                                applyReplacement();
                            } else {
                                $rootScope.service.staff.setStaffRepCustomerCode($scope.visible_replacement.customer_code, applyReplacement)
                            }

                        });
                    } else {
                        $scope.visible_customer = $rootScope.model.account.customer_data;
                        $scope.waiting_for_data = false;
                    }
                })
            });

        })
    }

    function applyMessages(setRecentlyAdded, setPaymentAccepted, setPaymentDeclined){
        $scope.visible_replacement.messages = $scope.visible_replacement.messages ? $scope.visible_replacement.messages: [];
        $scope.visible_replacement.reverse_messages = $scope.visible_replacement.messages.slice().reverse();
        let haveCustomerMessage = false;
        for(let i = 0; i < $scope.visible_replacement.reverse_messages.length; i ++){
            const message = $scope.visible_replacement.reverse_messages[i];
            if(message.from === "customer"){
                haveCustomerMessage = true;
            }
            message.recently_added = setRecentlyAdded && i === 0;
            if(message.type === 'payment_request'){
                if(setPaymentAccepted){
                    message.payment_accepted = true;
                } else if(setPaymentDeclined){
                    message.payment_declined = true;
                }
                message.have_customer_message = haveCustomerMessage;
            }
        }
    }

    $scope.addMessage = function (validateFormCallback) {
        $scope.view_model.form_disabled = true;
        $scope.image_file_upload_model.cleanup = true;
        $rootScope.service.order_replacement.addMessage($scope.replacement_id, $scope.view_model.user_message, function (success, response, messages) {
            $scope.view_model.form_disabled = false;
            if(success){
                $scope.view_model.user_message = "";
                $scope.visible_replacement.messages.push(response);
                applyMessages(true);
            }
            validateFormCallback(success, messages)
        });
    }

    $scope.addImage = function (validateFormCallback) {
        $scope.view_model.form_disabled = true;
        $scope.image_file_upload_model.cleanup = true;
        $rootScope.service.order_replacement.addImage($scope.replacement_id, $scope.view_model.user_images[0], function (success, response, messages) {
            $scope.view_model.form_disabled = false;
            if(success){
                $scope.image_file_upload_model.reset = true;
                $scope.visible_replacement.messages.push(response);
                applyMessages(true);
            }
            validateFormCallback(success, messages)
        });
    }


    $scope.submitStaffReplacement = function (validateFormCallback) {

        $scope.view_model.form_disabled = true;
        $scope.image_file_upload_model.cleanup = true;
        $rootScope.service.staff_order_replacement.submitStaffReplacement($scope.visible_replacement, function (success, order, messages) {
            $scope.view_model.form_disabled = false;
            if (success) {
                if(originalOrder){
                    const originalOrderLines = originalOrder?.lines ?? [];
                    const orderLines = [];
                    for(let replacementLine of $scope.visible_replacement.lines)
                    {
                        let replacementOrderLine = replacementLine.order_line;
                        if(!replacementOrderLine){
                            continue
                        }
                        replacementOrderLine = JSON.parse(JSON.stringify(replacementOrderLine));
                        let orderLine = {};
                        if(replacementLine.order_line_id) {
                            let lineIndex = parseInt(replacementLine.order_line_id) - 1;
                            orderLine = JSON.parse(JSON.stringify(originalOrderLines[lineIndex]));
                        }
                        for(let key in replacementOrderLine){
                            orderLine[key] = replacementOrderLine[key];
                        }
                        orderLines.push(orderLine);
                    }
                    if(orderLines.length){
                        $rootScope.service.tracking.track_sale(originalOrder, {lines: orderLines, list_name: "Replacement"});
                    }
                }
            }
            validateFormCallback(success, messages);
        });

    };
    $scope.respondPayment = function (validateFormCallback, data) {
        const isAccept = !!data && !!data.is_accept;
        $scope.view_model.form_disabled = true;
        $rootScope.service.order_replacement.respondPayment($scope.replacement_id, isAccept, function (success, response, messages) {
            $scope.view_model.form_disabled = false;
            if(success){
                applyMessages(false, isAccept, !isAccept);
            }
            validateFormCallback(success, messages)
        });
    }

}]);